import Typography from 'components/atoms/Typography';
import CloudinaryImageUploader, { CloudinaryImageUploadProps } from 'components/organisms/CloudinaryImageUpload';
import KIT_BANNER from 'assets/Kit_banner.png';

// Not sure what should be passed to the 2 anys to provide the proper data.
interface HubAuthoringHeaderMediaProps extends CloudinaryImageUploadProps {
  header: string;
  subHeader?: string;
  previewWidth: number;
  className?: string;
  required?: boolean;
  error?: string;
}

const HubAuthoringHeaderMedia = ({
  header,
  subHeader,
  previewWidth,
  className,
  existingImg,
  handleImgSelect,
  required,
  error,
  ...cloudinaryImageUploaderProps
}: HubAuthoringHeaderMediaProps) => {
  return (
    <div className={className}>
      <Typography className="mt-3" variant="h5">
        {header}
        {required && <span className="text-red text-xs">*</span>}
      </Typography>
      <Typography className="mt-2" variant="xs">
        {subHeader}
      </Typography>
      {error && (
        <Typography className="mt-2 text-red" variant="base">
          {error}
        </Typography>
      )}
      <CloudinaryImageUploader
        preview
        fileFilter="image/*,video/*"
        placeholder={KIT_BANNER}
        existingImg={existingImg}
        handleImgSelect={handleImgSelect}
        className="my-2"
        {...cloudinaryImageUploaderProps}
        imageWidth={previewWidth}
      />
    </div>
  );
};

export default HubAuthoringHeaderMedia;
